import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { CommonDI, PriceLegalMentionsRepositoryType } from '@headless-workspace/domain/common/DI';
import { DataLayerClassName, TargetedProductCarousel } from '@headless-workspace/domain/common/client';
import { AsyncComponent } from '@headless-workspace/domain/common/server';
import { PropsWithClassName, PropsWithLocale } from '@headless-workspace/glow-ds';

type HomeTargetedProductCarouselSectionProps = PropsWithLocale &
    PropsWithClassName & {
        carouselId: string;
    };

export const HomeTargetedProductCarouselSection: AsyncComponent<HomeTargetedProductCarouselSectionProps> = async ({
    carouselId,
    locale,
    className,
}) => {
    const enablePriceLegalMentionsResult = await CommonDI.get(
        PriceLegalMentionsRepositoryType,
    ).fetchEnablePriceLegalMentions(locale);
    const enablePriceExceptionLegalMentions = unwrapResultSuccess(enablePriceLegalMentionsResult) ?? false;

    return (
        <div className={DataLayerClassName.targetedCarousel}>
            <TargetedProductCarousel
                carouselId={carouselId}
                locale={locale}
                enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
                className={className}
            />
        </div>
    );
};
